<div class="container">
  <form
    class="form-inline mt-4 d-flex justify-content-center"
    (ngSubmit)="handleFind()"
  >
    <div class="form-group">
      <label for="userName">User Name</label>
      <input
        [(ngModel)]="userName"
        type="text"
        id="userName"
        class="form-control mx-sm-3"
        name="userName"
      />
    </div>
    <button type="submit" class="btn btn-primary mb-2">Find User</button>
  </form>

  <div *ngIf="error" class="alert alert-danger m-5">{{ error }}</div>

  <div class="row mt-3">
    <div class="col col-md-4">
      <app-user-card *ngIf="user" [user]="user"></app-user-card>
    </div>
    <div class="col col-md-8">
      <app-repos *ngIf="user" [repoUrl]="user.repos_url"></app-repos>
    </div>
  </div>
</div>
